import { FC, ReactNode } from 'react';
import cx from 'classnames/bind';

import styles from './Info.module.scss';

interface InfoProps {
  children: ReactNode;
}

const cn = cx.bind(styles);

const Info: FC<InfoProps> = ({ children }) => (
  <div className={cn('wrapper')}>{children}</div>
);

export default Info;
